import signupstepsMdl from "./signupsteps.mdl";
import stripePlan from "./stripePlan.mdl";

export default [
  ...signupstepsMdl,
  ...stripePlan,
];
